import { Injectable } from '@angular/core';
import { TokenService } from '@cargos/sprintpay-services';

@Injectable({
    providedIn: 'root',
})
export class CargoSprintLibraryService {
    constructor(private tokenService: TokenService) {}

    getConfigSprintLibrary() {
        return {
            token: this.tokenService.instant_token,
            environment: null,
        };
    }
}
